export const blockIconsNavigationMoreHoriz = (
	<span className='material-symbols-outlined'>more_horiz</span>
);
